module.exports = __webpack_public_path__ + "static/media/ips.cbbad482.png";